module.exports = __webpack_public_path__ + "static/media/Water.89ee9511.png";